<script setup>


</script>

<template>
  <!-- PAGE HEADING -->
  <div class="impx-page-heading uk-position-cover rooms">
    <div class="impx-overlay dark"></div>
    <div class="uk-container">
      <div class="uk-width-1-1">
        <div class="uk-flex uk-flex-bottom">
          <div class="uk-light uk-position-relative uk-text-left page-title">
            <h1 class="uk-margin-remove">Nos Appartements de Luxe</h1><!-- page title -->
            <p class="impx-text-large uk-margin-remove">Votre confort, votre choix</p><!-- page subtitle -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- PAGE HEADING END -->

</template>

<style scoped>

</style>